// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"57aad685","732":"d4ee1802"}[chunkId] + ".chunk.js";
};